<template>
    <pre v-if="isDevelopment" class="debug">{{ data }}</pre>
</template>
<script setup>
import { computed } from 'vue';
import { useAttrs } from '#imports';

defineOptions({
    inheritAttrs: false,
});

const isDevelopment = computed(() => process.env.NODE_ENV === 'development');
const data = computed(() => ({
    ...useAttrs(),
}));
</script>
<style scoped>
.debug {
  display: grid;
  max-width: var(--desktop-max-width);
  width: 100%;
  margin: 0 auto;
}
.debug .inner {
  max-width: var(--page-max-width);
  margin: 0 auto;
  padding-left: 1.5rem;
  width: 100%;
  padding-right: 1.5rem;
}
.debug {
  overflow-x: scroll;
}
</style>
